<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="mes"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="auto"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="formatedMesAno"
        :label="label"
        prepend-icon="calendar_month"
        readonly
        v-bind="attrs"
        :disabled="disabled"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="mes"
      type="month"
      no-title
      scrollable
      :max="resolvedMaxDate"
      :allowed-dates="allowedDate || undefined"
    />
  </v-menu>
</template>

<script>
export default {
  name: "MonthFilterPicker",
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    label: {
      type: String,
      default() {
        return "Escolha um Mês/Ano";
      },
    },
    mesAno: {
      type: String,
      default() {
        return "";
      },
    },
    maxDate: {
      type: String,
      default() {
        return "";
      },
    },
    allowedDate: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      mes: "",
      menu: false,
    };
  },
  computed: {
    formatedMesAno: {
      get() {
        if (!this.mes) {
          return "";
        }

        const [year, month] = this.mes.split("-");
        return `${month}/${year}`;
      },
      set(newValue) {
        if (!newValue) {
          this.mes = "";
          return;
        }

        const [month, year] = newValue.split("/");
        this.mes = `${year}-${month}`;
      },
    },
    resolvedMaxDate() {
      if (this.maxDate) {
        return this.maxDate;
      }

      const today = new Date();
      const year = today.getFullYear();
      const month = `${today.getMonth() + 1}`.padStart(2, "0");

      return `${year}-${month}`;
    },
  },
  watch: {
    mes(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        const [year, month] = newValue.split("-");
        this.$emit("mesAno", `${month}/${year}`);
        this.$refs.menu.save(newValue);
      }

      if (!newValue) {
        this.$emit("mesAno", null);
      }
    },
    mesAno: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          this.mes = "";
          return;
        }

        if (newValue.includes("/")) {
          const [month, year] = newValue.split("/");
          this.mes = `${year}-${month}`;
          return;
        }

        this.mes = newValue;
      },
    },
  },
};
</script>
